import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PageLayout from "../../../layouts/PageLayout";
import { SidebarContext } from "../../../context/Sidebar";
import "../../../assets/fonts/ExpenseEntry.css";

const EXPENSE_OPTIONS = [
  {
    key: "daily",
    label: "Daily Expenses",
    icon: "fa-solid fa-calendar-day",
    color: "#4CAF50",
    colorDark: "#2E7D32",
  },
  {
    key: "utility",
    label: "Utility Expenses",
    icon: "fa-solid fa-bolt",
    color: "#2196F3",
    colorDark: "#1565C0",
  },
];

export default function ExpenseTypeSelect() {
  const navigate = useNavigate();
  const { setSidebar } = useContext(SidebarContext);

  useEffect(() => {
    setSidebar(false);
  }, [setSidebar]);
  

const handleSelect = (type) => {
  navigate(`/expense-create/${type}`);
};

  return (
    <PageLayout>
      <div className="pe-scope">
        <div className="pe-page pb-5">
          <div className="container py-5" style={{ maxWidth: "900px" }}>
            <div className="pe-hero mb-5 text-center">
              <span className="pe-eyebrow">Accounts · Expenses</span>
              <h1 className="pe-title">Select Expense Type</h1>
              <p className="pe-subtitle">
                Choose which expense section you want to open.
              </p>
            </div>

            <div className="row g-4 justify-content-center">
              {EXPENSE_OPTIONS.map((item) => (
                <div className="col-12 col-sm-6" key={item.key}>
                  <button
                    type="button"
                    onClick={() => handleSelect(item.key)}
                    className="metal-select-card"
                    style={{
                      "--metal-color": item.color,
                      "--metal-color-dark": item.colorDark,
                    }}
                  >
                    <i className={item.icon}></i>
                    <span>{item.label}</span>
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}